<form [formGroup]="workOrderFilterForm">
  <div class="form-content">
    <div class="pure-g">
      <div class="pure-u-md-24-24">
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <app-aems-multiline-tag-input
            fit="small"
            label="Equipment Id(s)"
            placeholder="Enter equipment number(s)"
            [regex]="equipmentNumberRegex"
            formControlName="equipmentId"></app-aems-multiline-tag-input>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <app-aems-multiline-tag-input
            fit="small"
            label="Workorder Numbers"
            placeholder="Enter workorder number(s)"
            [regex]="workorderRegex"
            formControlName="woNumber"></app-aems-multiline-tag-input>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-multi-select label="Mode" fit="small" width="100" placeholder="Select an Option" ngDefaultControl formControlName="mode">
            @for (mode of modes; track mode.repairMode) {
              <mc-option [attr.data-cy]="mode.repairMode" [value]="mode">{{ mode.repairMode }} {{ mode.modeDescription }} </mc-option>
            }
          </mc-multi-select>
        </div>
        @if (bindMultiSelects) {
          <div class="pure-u-md-12-24 p-b-16 p-r-16">
            <mc-multi-select
              label="Status"
              fit="small"
              width="100"
              placeholder="Select an Option"
              ngDefaultControl
              formControlName="status">
              @for (status of statuses; track status.generatedCode) {
                <mc-option [attr.data-cy]="status.description" [value]="status">{{ status.description }}</mc-option>
              }
            </mc-multi-select>
          </div>
        }
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-input-date
            fit="small"
            label="From"
            startofweek="1"
            format="DD-MM-YYYY"
            nextlabel="Next month"
            previouslabel="Previous month"
            placeholder="DD-MM-YYYY"
            width="auto"
            ngDefaultControl
            formControlName="fromDate"
            data-cy="from-date">
          </mc-input-date>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-input-date
            fit="small"
            label="To"
            startofweek="1"
            format="DD-MM-YYYY"
            nextlabel="Next month"
            previouslabel="Previous month"
            placeholder="DD-MM-YYYY"
            width="auto"
            ngDefaultControl
            formControlName="toDate"
            data-cy="to-date">
          </mc-input-date>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-multi-select
            label="Region"
            fit="small"
            width="100"
            placeholder="Select an Option"
            ngDefaultControl
            formControlName="region"
            (optionselected)="onRegionSelected($event)">
            @for (loc of regions; track loc) {
              <mc-option [attr.data-cy]="loc.name" [value]="loc.code"> {{ loc.name }}</mc-option>
            }
          </mc-multi-select>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-multi-select
            label="Cluster"
            fit="small"
            width="100"
            placeholder="Select an Option"
            ngDefaultControl
            formControlName="cluster"
            (optionselected)="onClusterSelected($event)">
            @for (clusterCode of clusters; track clusterCode) {
              <mc-option [attr.data-cy]="clusterCode.name" [value]="clusterCode.code"> {{ clusterCode.code }}</mc-option>
            }
          </mc-multi-select>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-select
            label="Assigned To"
            fit="small"
            width="100"
            placeholder="Select an Option"
            ngDefaultControl
            formControlName="assignedTo">
            @for (assignee of assigneeList; track assignee.loginName) {
              <mc-option [attr.data-cy]="assignee.loginName" [value]="assignee.loginName">{{ assignee.loginName }}</mc-option>
            }
          </mc-select>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <app-aems-multiline-tag-input
            label="Shop Id(s)"
            [transformToUppercase]="true"
            placeholder="Enter shop Id(s)"
            [regex]="shopIdRegex"
            formControlName="shop"></app-aems-multiline-tag-input>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-checkbox-group fit="small" legend="Work order on hold" style="display: grid">
            <div class="pure-g">
              <mc-checkbox
                class="pure-u-md-4-24"
                [checked]="workOrderFilterForm.get('isOnHold')?.value === true"
                label="Yes"
                (change)="onCheckChange(true)"></mc-checkbox>
              <mc-checkbox
                class="pure-u-md-4-24"
                [checked]="workOrderFilterForm.get('isOnHold')?.value === false"
                label="No"
                (change)="onCheckChange(false)"></mc-checkbox>
            </div>
          </mc-checkbox-group>
        </div>
      </div>
    </div>
  </div>
  <div class="pure-u-md-24-24 utility-buttons">
    <mc-button
      label="Apply Filters"
      slot="primaryAction"
      variant="filled"
      appearance="primary"
      fit="small"
      (click)="applyFilters()"
      class="p-r-16"></mc-button>
    <mc-button
      label="Clear Filters"
      slot="secondaryAction"
      appearance="neutral"
      fit="small"
      (click)="clearFilters()"
      class="p-r-16"></mc-button>
  </div>
</form>
